<template>
  <div class="content_block_container">
    <b-row class="content_block_topbar">
      <b-col><h5 class="title_content_block">Image</h5></b-col>
      <b-col style="text-align: right">
        <b-button
          class="controller_button_content"
          @click="$emit('shiftUpBlock', index)"
          ><b-icon icon="caret-up-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('shiftDownBlock', index)"
          ><b-icon icon="caret-down-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('deleteBlock', index)"
          ><b-icon icon="trash-fill" aria-hidden="true"></b-icon
        ></b-button>
      </b-col>
    </b-row>
    <b-container class="form_button_content">
      <b-row>
        <b-col sm="3">
          <p>Url:</p>
        </b-col>
        <b-col sm="6">
          <b-form-input
            v-model="image_property.url"
            placeholder="Url"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <p>Largeur ({{ image_property.largeur }}%):</p>
        </b-col>
        <b-col sm="6">
          <b-form-input
            id="range-1"
            v-model="image_property.largeur"
            type="range"
            min="10"
            max="100"
            style="margin-top: 10px"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="3">
          <p>Alignement:</p>
        </b-col>
        <b-col sm="6">
          <b-form-select
            v-model="image_property.alignement"
            :options="options_align"
          ></b-form-select>
        </b-col>
      </b-row>
    </b-container>
    <div class="button_previsualisation_container">
      <p :style="{ textAlign: image_property.alignement }">
        <img
          v-if="image_property.url"
          :src="image_property.url"
          :style="{
            width: image_property.largeur + '%',
            height: 'auto',
            display: 'inline',
          }"
        />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["image_property", "index"],
  data() {
    return {
      options_align: [
        { text: "Gauche", value: "left" },
        { text: "Centre", value: "center" },
        { text: "Droite", value: "right" },
      ],
    };
  },
};
</script>

<style scoped>
</style>